<template>
  <div>
    <header
      style="background:#78adcb"
      @click="$router.push(`${isshow == true ? '/regular' : '/shopping'}`)"
    >
      <span class="iconfont icon-xiangzuo1 left"></span>
      <span class="centent">购物车</span>
    </header>
    <!-- 备货 -->
    <div
      style="font-size: 0.4rem; margin-top: 1.8rem; text-align: left"
      class="zz q"
      v-if="isshow"
    >
      <span class="zz">
        <span class="public-meter">
          {{ customName }}&nbsp;&nbsp;
        </span>
      </span><br />
      <div class="demonstrate">
        <span style="">
          <span class="tab organ">单号：</span>
          <span class="lable">{{bizCode}}</span>
        </span>
        <span class="unfold" @click="unfold">{{unfoldShow?'收起':'展开'}}</span>
          <br/>
        <span style="">
          <span class="tab organ">收货地址：</span>
          <span class="lable">
            {{ address == "undefined" ? "" : address }}
          </span> 
        </span><br/>
        <span style="">
          <span class="tab organ" >发货机构：</span>
          <span class="lable">{{
            DepotName
          }}
        </span>
          </span><br />

        <li class="remark" @click="zshow = true">
          <span 
            class="tab remark-sublevel">备注：</span>
            <span  class="range">
              {{remark}}
            </span>
          <span class="iconfont icon-qicaodianjihou" v-show="unfoldShow"></span>
        </li>
      </div>
    </div>
    
    <!-- 申领 -->
    <div
      style="font-size: 0.4rem; margin-top: 1.8rem; text-align: left"
      class="zz q"
      v-else
    >
      <span class="zz">
        <span style="font-weight: 800; margin-left: 0px">{{ fromDepotName }}&nbsp;&nbsp;</span>
      </span><br />

      <div  class="demonstrate">
        <span style="">
          <span
            class="tab organ"
            >单号：</span>
            <span style="font-weight: 400">{{ bizCode }}</span>
          </span>
          <span class="unfold" @click="unfold">{{unfoldShow?'收起':'展开'}}</span>
          <br  />
      
        <span style="">
          <span class="tab organ">收货地址：</span>
          <span style="font-weight: 400">{{toAddress == "undefined" ? "" : toAddress}}</span></span><br/>
        <span style=""
          ><span
            class="organ"
            >发货机构：</span
          ><span style="font-weight: 400">{{ toDepotName }}</span></span>
        <li class="remark" @click="zshow = true">
           <span 
            class="tab remark-sublevel">备注：</span>
            <span style="font-weight: 400; font-size: 0.37rem;flex:.83" class="range">
              {{remark}}
            </span>
          <span class="iconfont icon-qicaodianjihou" v-show="unfoldShow"></span>
        </li>
      </div>
    </div>
    
  
    
    <div class="box" v-if="replenishType == 'fix_wrapper_specification'||'fix_wrapper'">
      <main
        @click="add(item)"
        v-for="(item, index) in list"
        :key="item.bizItemId"
      >

           <input
              type="checkbox"
              name=""
              id=""
              class="select-shopping"
              @change.stop="changeState(item,index)"
            />
        <div class="vessell">
          <div>
            <span class="class" style="margin-left: 0rem" v-if="replenishType == 'fix_wrapper_specification'" >(定数规格)</span>
            <p class="title" :style="{ textIndent: replenishType == 'fix_wrapper_specification' ? '5.4em' : '',}">
              {{ item.fixWrapperSpecificationName }}
            </p>
            
            
            <!-- 全做判断了，懒得加页面什么的 -->
            <div class="About_type_info">
               <p class="state">
                 {{replenishType=='fix_wrapper'?'标签':'定数规格'}}：
                 {{replenishType=='fix_wrapper'?item.wrapperNo: item.fixWrapperSpecificationTypeCode }}
               </p>
               <p class="state" style="color: rgb(137, 152, 152)">
                 {{replenishType=='fix_wrapper'?'类别':'定数分类'}}：
                 {{replenishType=='fix_wrapper'? item.sortName:item.fixWrapperSortName }}
               </p>
            </div>
          </div>
        </div>
        <p class="price unit" style="margin-left: 13px">
          <span style="font-size: 0.5rem">￥{{ item.unitPrice }}</span>/{{ item.unitName }}
        </p>
        <div class="amount">
          <div class="but"></div>
        </div>
        <van-stepper
          v-model="value[index]"
          class="stepper"
          @blur="blurNum(item, index)"
          @plus="plusNum(item, index)"
          @minus="minusNum(item, index)"
          input-width="50px"
        />

          <span v-if="item.fixWrapperSpecificationTypeCode=='单品溯源规格'" class="iconfont icon-suyuan check-img-about" @click="details(item)"> </span>
          <span v-else-if="item.fixWrapperSpecificationTypeCode=='复合组包规格'" class="iconfont icon-listzuhe check-img-about" @click="details(item)"> </span>
          <span v-else class="iconfont icon-xiangqing check-img-about" @click="details(item)"></span>
       
      </main>
    </div>

    <div class="box" v-else>
      <main @click="add" v-for="(item, index) in list" :key="item.bizItemId">

            <input
              type="checkbox"
              name=""
              id=""
              class="select-shopping"
              @change.stop="changeState(item,index)"
            />
        <div class="vessell">
          <div>
            <p
              class="title"
              :style="{
                textIndent:
                  replenishType == 'fix_wrapper_specification' ? '5.5em' : '',
              }"
            >
              {{ item.goodsFormatName }}
            </p>
              
           
            &nbsp;<span class="state">{{ item.sortName }}&nbsp;<br /> </span>
          </div>
        </div>
        
        <p class="price unit" style="margin-left: 13px">
          <span style="font-size: 0.5rem">
            ￥{{ item.unitPrice }}
          </span>/
          <span class="tab">{{ item.unitName }}</span>
        </p>
        <div class="amount">
          
          <div class="but"></div>
        </div>
        <van-stepper
          v-model="value[index]"
          class="stepper"
          @blur="blurNum(item, index)"
          @plus="plusNum(item, index)"
          @minus="minusNum(item, index)"
          input-width="50px"
        />
      </main>
    </div>

   <div class="info-box">
       <div class="info">
      <div class="works-icon">

                <!-- 全选 -->
    <div class="check_all" @click="checkAll">
      <li ><span class="iconfont icon-quanxuan"></span> {{checkAllShow?'全选':'取消'}}</li>
    </div>
        <!-- 添加图标 -->
        <span
          class="iconfont icon-tianjia"
          @click="skip"
        ></span>
        <!-- 删除图标 -->
        <span
          class="iconfont icon-qunfengshanchuchong"
          @click="deleteAffirm()"
        ></span>
      
      </div>
      <p class="commodity">
        共 <span class="hint">{{ allNum }}</span> 种
        <span class="hint">{{replenishType=="fix_wrapper"?list.length: sum }}</span> 件商品
      </p>
      <p>
        <span class="commodity"
          >总金额</span
        >
        ：<span class="hint"
          >￥{{
            replenishType == "fix_wrapper_specification" ? count.toFixed(2)||'': totalAmount.toFixed(2)||''
          }}</span
        >
      </p>
    </div>


    <div class="close" >
      <button @click.stop="cancelForm" class="smbut" style="background: red">
        取消
      </button>
      <button @click.stop="addAffirm" class="smbut">确认</button>
    </div>
   </div>

    <!-- 表单提交的 -->

    <!-- 修改备注的 -->
    <van-popup v-model="zshow" position="bottom" round  :style="{ height: '70%' }"  >
            <div class="" @click.stop="w">
        <p style="font-size: 0.5rem" class="remark-text">订单备注</p>
        
        <p class="remark-title">
          <textarea
            name=""
            id=""
            cols="32"
            rows="9"
            style="margin-top:0%"
            class="remark-input"
            v-model="remark"
          ></textarea>
        </p>
        <button class="unite" @click="updataRemark">修改</button>
      </div>
    </van-popup>



    
    <van-overlay :show="show" @click="show = false">
      <div class="password" @click.stop="w">
        <p style="font-size: 0.5rem">确认表单</p>
  
        <div style="font-size: 0.37rem; margin-top: 30px">
          <div style="text-align: left;line-height: 21px;">
            <span class="tab">规则：</span>
            <span>{{isshow ? customName : fromDepotName}}</span><br>

            <span class="tab">单号：</span> 
            <span>{{bizCode}}</span>&nbsp; <br>
            
            <span class="tab">收货地址：</span>
            <span>{{isshow ? address : toAddress}}</span><br>

            <span class="tab">发货机构：</span>
            <span>{{isshow ? DepotName : toDepotName}}</span><br>

            <span class="tab">总数量：</span>
            <span style="color:red;">{{replenishType=="fix_wrapper"?list.length: sum}}</span><br>

            <span class="tab">总金额：</span>
            <span style="color:red;">{{replenishType == "fix_wrapper_specification" ? count.toFixed(2)||'' : totalAmount.toFixed(2)||''}}</span><br>

            <li class="remark">
              <span class="tab" style="flex:.12;">备注：</span>
              <span class="" style="flex:.88">{{remark}}</span><br>
            </li>
            
          </div>

        </div>
        <p style="font-size: 0.37rem; margin-top: 10px">
         
        </p>
        <button class="unite" @click="addCommit">确认</button>
      </div>
    </van-overlay>
    <Tabbar></Tabbar>
  </div>
</template>

<script>
import Tabbar from "../components/tabber";
import {
  selectedItems,
  deleteItem,
  addCommit,
  updateNumber,
  deleteAll,
  modifyRemark,
} from "../api/shopping";
import { Dialog } from "vant";
import { set } from 'vue';

export default {
  components: {
    Tabbar,
  },
  data() {
    return {
      zshow: false,
      isshow: true,
      show: false,
      checkAllShow:true,
      remark: localStorage.getItem("remark") || "",
      amount: localStorage.getItem("amount") || 0,
      high: false,
      value: [],
      list: [],
      num: localStorage.getItem("planTotalAmount") || "",
      arr: [],
      replenishType: localStorage.getItem("replenishType") || "",
      customName: localStorage.getItem("customName") || "",
      address: localStorage.getItem("address") || "",
      DepotName: localStorage.getItem("DepotName") || "",
      fromDepotName: localStorage.getItem("fromDepotName") || "",
      toAddress: localStorage.getItem("toAddress") || "",
      toDepotName: localStorage.getItem("toDepotName") || "",
      currentPage: 1,
      deleteShow: true,
      priceArry: [],
      spdUserCode: localStorage.getItem("spdUserCode"),
      bizCode: localStorage.getItem("bizCode"),
      timer:null,
      timer2:null,
      unfoldShow:false
    };
  },
  created() {

    // 清除查询条件
    localStorage.removeItem('infoObj')
    localStorage.removeItem('showInfo')
    localStorage.removeItem('Classfit')
    localStorage.removeItem('specificationValue')
    localStorage.removeItem('checked')
    localStorage.removeItem('keyValue')
    localStorage.removeItem('keyName')
    localStorage.removeItem('checkedDefault')
    var state=localStorage.getItem('state')
    if(state=="0"){
      this.isshow=false
    }else{
      this.isshow=true
    }
    this.selectedItems();
  },

  mounted() {
    window.addEventListener("scroll", this.getbottom, true);
  },
  methods: {
    getbottom() {
      // 返回滚动条垂直滚动距离
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 返回该元素的像素高度，高度包含内边距（padding），不包含边框（border），外边距（margin）和滚动条
      const clientHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      // 返回该元素的像素高度，高度包含内边距（padding），不包含外边距（margin）、边框（border）
      const scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      const numHeight = scrollTop + clientHeight;
      if (scrollHeight > clientHeight && numHeight > scrollHeight - 1) {
        // this.selectedItems();
      }
    },

    ad() {
      this.list.push({ id: Math.random() });
    },

    skip(){
        this.$router.push({
          name:'classification',
          params:{
            sortId:this.$route.params.sortId
          }
        })
    },

    // 全选
    checkAll(){
    
     let checkAll=document.querySelectorAll('.select-shopping')
      if (this.list[0].bizItemId) {
        if(this.checkAllShow){
           this.list.forEach((k,index)=>{
           checkAll[index].checked=true
           this.arr.push(k.bizItemId);
          })
        }else{
           this.list.forEach((k,index)=>{
             checkAll[index].checked=false
             this.arr=[];
           })
        }

      } else {

       if(this.checkAllShow){
           this.list.forEach((k,index)=>{
           checkAll[index].checked=true
           this.arr.push(k.itemId);
          })
        }else{
           this.list.forEach((k,index)=>{
             checkAll[index].checked=false
             this.arr=[];
           })
        }

      }  

      this.checkAllShow=!this.checkAllShow
    },
    // 选项框的函数
    changeState(item,index) {
     
      if (item.itemId) {
        if (this.arr.indexOf(item.itemId) == -1) {
          this.arr.push(item.itemId);
        } else {
          var num = this.arr.indexOf(item.itemId);
          this.arr.splice(num, 1);
        }
      } else {
        if (this.arr.indexOf(item.bizItemId) == -1) {
          this.arr.push(item.bizItemId);
        } else {
          var num = this.arr.indexOf(item.bizItemId);
          this.arr.splice(num, 1);
        }
      }  
    },

    // 防抖函数
    debounce(func, delay) {
      let context = this; // this指向发生变化，需要提出来
      let args = arguments;
      return (function () {
        if (context.timeout) {
          clearTimeout(context.timeout);
        }
        context.timeout = setTimeout(() => {
          func.apply(context, args);
        }, delay);
      })(); // 注意:我加了()
    },

    // 加
    plusNum(item, index) {
       var flg=this.stop()
      if(flg){
         this.debounce(async () => {
        const res = await updateNumber({
          yardId: localStorage.getItem("yardId"),
          openId: localStorage.getItem("openid"),
          opId: localStorage.getItem("opId"),
          bizType: localStorage.getItem("bizType"),
          replenishType: localStorage.getItem("replenishType") || null,
          bizItemId: item.bizItemId || item.itemId,
          planQty: this.value[index],
          spdUserCode: this.spdUserCode,
        });
        try {
          if (res.data.successFlag) {
            this.$toast.success("数量修改成功");
          } else {
           this.$toast.fail(res.data.msg);
          }
        } catch (err) {}
      }, 600);
      }else{
        
        this.value[index]=100
      }
    },

    // 直接输入数量
    async blurNum(item, index) {
        var flg=this.stop()
        if(flg){
          const res = await updateNumber({
        yardId: localStorage.getItem("yardId"),
        openId: localStorage.getItem("openid"),
        opId: localStorage.getItem("opId"),
        bizType: localStorage.getItem("bizType"),
        replenishType: localStorage.getItem("replenishType") || null,
        bizItemId: item.bizItemId || item.itemId,
        planQty: this.value[index],
        spdUserCode: this.spdUserCode,
      });
      try {
        if (res.data.successFlag) {
          this.$toast.success("数量修改成功");
        } else {
          this.$toast.fail(res.data.msg);
        }
      } catch (err) {}
        }
    },
    // 减
    async minusNum(item, index) {
      var flg=this.stop()
      
      if(flg){
          this.debounce(async () => {
         const res = await updateNumber({
          yardId: localStorage.getItem("yardId"),
          openId: localStorage.getItem("openid"),
          opId: localStorage.getItem("opId"),
          bizType: localStorage.getItem("bizType"),
          replenishType: localStorage.getItem("replenishType") || null,
          bizItemId: item.bizItemId || item.itemId,
          planQty: this.value[index],
          spdUserCode: this.spdUserCode,
        });
        try {
          if (res.data.successFlag) {
            this.$toast.success("数量修改成功");
          } else {
            this.$toast.fail(res.data.msg);
          }
        } catch (err) {}
      }, 600);
      }else{
        this.value[index]=this.value[index]-1
      }
    },

    // 如果是定数包就不能修改数量
    stop(){
      if(this.replenishType=='fix_wrapper'){
        this.$toast.fail('定数包不可修改数量')
        return false
      }else{
        return true
      }
    },

    async selectedItems() {
      this.$store.commit("loadHandler", {
        // 调用加载动画
        _this: this,
        boolean: true,
      });
      const res = await selectedItems({
        yardId: localStorage.getItem("yardId"),
        openId: localStorage.getItem("openid"),
        opId: localStorage.getItem("opId"),
        bizId: localStorage.getItem("bizId"),
        bizType: localStorage.getItem("bizType"),
        openId: localStorage.getItem("openid"),
        replenishType: localStorage.getItem("replenishType") || null,
        currentPage: -1,
        pageSize: -1,
        spdUserCode: this.spdUserCode,
      });
      try {
       
        this.value=[]
        this.priceArry=[]
        if (res.data.data.length == 0) {
          // debugger
          window.removeEventListener("scroll", this.getbottom, true);
        }
       

        this.currentPage = this.currentPage + 1;
        res.data.data.forEach((item, index) => {
          this.list.push(item);
        });
       
        this.list.forEach((item,index)=>{
          this.value.push(item.planQty);
          this.priceArry.push(item.unitPrice);
        })
      
        
        this.$store.commit("loadHandler", {
          // 调用加载动画
          _this: this,
          boolean: false,
        });

        // this.$toast.success('')
      } catch (err) {
        console.log(err);
        this.$store.commit("loadHandler", {
          // 调用加载动画
          _this: this,
          boolean: false,
        });
      }
    },

    // 修改备注
    async updataRemark() {
      if (this.remark == "") {
        this.$toast.fail("请填写备注");
        return;
      }
      const res = await modifyRemark({
        yardId: localStorage.getItem("yardId"),
        openId: localStorage.getItem("openid"),
        opId: localStorage.getItem("opId"),
        bizId: localStorage.getItem("bizId"),
        bizType: localStorage.getItem("bizType"),
        spdUserCode: this.spdUserCode,
        remark: this.remark,
      });
      try {
        if (res.data.successFlag) {
          this.$toast.success("修改成功");
          this.zshow = false;
        } else {
          this.$toast.fail("修改失败");
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 阻止冒泡
    w() {},

    deleteAffirm() {
      
      if (this.list.length == 0) {
        this.$toast.fail("请增加产品");
        return;
      } else if (this.arr.length == 0) {
        this.$toast.fail("请选择产品");
      } else {
        Dialog.confirm({
          title: "删除产品",
          message: "确认删除该产品吗",
        })
          .then(() => {
            this.deleteItem();
          })
          .catch(() => {
            // on cancel
          });
      }
    },

    async deleteItem() {
      const res = await deleteItem({
        yardId: localStorage.getItem("yardId"),
        openId: localStorage.getItem("openid"),
        opId: localStorage.getItem("opId"),
        bizItemIds: this.arr,
        bizType: localStorage.getItem("bizType"),
        replenishType: localStorage.getItem("replenishType"),
        spdUserCode: this.spdUserCode,
      });
      try {

        if (res.data.successFlag) {
          this.$toast.success("删除成功");
          this.currentPage = 1;
          this.list = [];
          this.arr = [];
          setTimeout((item) => {
            this.selectedItems();
          }, 300);
        } else {
          this.$toast.fail(res.data.msg);
        }
      } catch (err) {
        console.log(err);
      }
    },

    cancelForm() {

      Dialog.confirm({
        title: "删除",
        message: `确认删除${
          this.isshow ? this.customName : this.fromDepotName
        }单吗？`,
      })
        .then(() => {
          this.cancel();
        })
        .catch(() => {
          
        });

    },


    // 取消表单
    async cancel() {
      const res = await deleteAll({
        yardId: localStorage.getItem("yardId"),
        openId: localStorage.getItem("openid"),
        opId: localStorage.getItem("opId"),
       
        bizType: localStorage.getItem("bizType"),
       
        bizId: localStorage.getItem("bizId"),
        spdUserCode: this.spdUserCode,
      });
      try {
   
        if (res.data.successFlag) {
          this.$toast.success("删除成功");
          this.$router.push("/shopping");
        }
      } catch (err) {
        console.log(err);
      }
    },
    add(item) {
     
    },

    // 点击展开
    unfold(){
      var demonstrate=document.querySelector('.demonstrate')
      var num=0
      
      if(!this.unfoldShow){
        
        this.timer= setInterval(() => {
           num=num+20
            demonstrate.style.height=num+'px'
            if(num==140){
            
             clearInterval(this.timer)
            }
         }, 10);
          this.unfoldShow=true
      }else{
       var num2=demonstrate.offsetHeight
        this.timer2= setInterval(() => {
           num2=num2-20
            demonstrate.style.height=num2+'px'
            if(num2==20){
              demonstrate.style.height=17+'px'
             clearInterval(this.timer2)
             
            }
           
         }, 10);
          this.unfoldShow=false
      }
   
    },

    details(item) {
      this.$router.push({
        name: "details",
        params: { fixWrapperSpecificationId: item.fixWrapperSpecificationId },
      });
    },

    addAffirm() {
      if (this.list.length == 0) {
        this.$toast.fail("请新增产品");
        return;
      }

      this.show = true;

    },
    // 提交函数
    async addCommit() {
      if(this.list.length==0){
        this.$toast.fail('请新增产品')
        return
      }
      this.$store.commit("loadHandler", {
        // 调用加载动画
        text: "提交中...",
        _this: this,
        boolean: true,
      });
      const res = await addCommit({
        yardId: localStorage.getItem("yardId"),
        openId: localStorage.getItem("openid"),
        opId: localStorage.getItem("opId"),
        bizId: localStorage.getItem("bizId"),
        bizType: localStorage.getItem("bizType"),
        spdUserCode: this.spdUserCode,
      });
      try {
        
        if (res.data.successFlag) {
          this.$store.commit("loadHandler", {
            // 调用加载动画
            _this: this,
            boolean: false,
          });
          this.$toast.success("提交成功");
          setTimeout(()=>{
            this.$router.push("/shopping");
          },1000)
        } else {
          this.$toast.fail(res.data.msg);
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
  computed: {
    totalAmount(){
      var num=0
      this.list.forEach((key,index)=>{
       num += key.totalAmount
      })
      return num
    },
    count() {
      var num = 0;
      this.value.forEach((item, index) => {
        num += item * this.priceArry[index];
      });

      // num = num;
      return num;
    },

    sum() {
      var num = 0;
      this.list.forEach((item, index) => {
        num += this.value[index];
      });
      return num;
    },

    allNum() {
      return this.list.length;
    },
  },

  beforeRouteEnter(to, from, next) {
    //  这个守卫还没有this所以要用next来调用
    next((vm) => {

      vm.$store.commit("routeryardId", {
        fromPath: from.path,
        _this: vm,
      });
    });
  },
  destroyed() {
    window.removeEventListener("scroll", this.getbottom, true);
  },
};
</script>

<style lang="less" >
/* @import '../assets/css/procurement.css'; */
* {
  margin: 0;
  padding: 0;
  list-style: none;
}
main {
  box-sizing: border-box;
  margin-top: 0;
  padding: 0.3rem 0 !important;
}
.box {
  padding: 0.2rem;
  box-sizing: border-box;
  position: relative;
  margin-bottom: 250px;
}

.info-box{
  width: 100%;
  position: fixed;
  bottom: 10px;
  background: white;
   
}

.stepper{
  position: absolute;
  bottom: 10px;
  right: 20px;
}

.unit{
  position: absolute;
  bottom: 10px;
  left: 10px;
}

.check_all li{
  background: #f2f1f1;
  padding: 3px 5px;
  border-radius: 5px;
  font-size: 10px;
  margin-top: 7px;
}

.demonstrate{
padding: 0.2rem 0.13rem;
height: 17px;
overflow: hidden;
}
// .title {
//   text-align: left;
//   line-height: 0.5rem;
//   margin-left: 0.5rem;
//   font-size: 0.37rem;
//   overflow: hidden;
//   text-overflow: ellipsis;
//   display: -webkit-box;
//   -webkit-line-clamp: 2;
//   -webkit-box-orient: vertical;
// }
.state {
  color: rgb(137, 132, 132);
  font-size: 0.37rem;
}
.state2 {
  margin-top: 0rem;
  color: black;
}
.vessell {
  display: flex;
  position: relative;
  
}

.btn {
  margin-top: 0.6rem;
}
.clear {
  height: 0.7rem;
  font-size: 0.5rem;
  width: 1.4rem;
  font-size: 0.4rem;
  background: white;
  border: 1px solid black;
}

.high {
  border: 1px solid red;
  border-radius: 10px;
  box-sizing: border-box;
}
.info {
  width: 100%;
  text-align: right;
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  padding: 0.4rem 0.5rem;
  box-sizing: border-box;
  font-size: 0.4rem;
  position: relative;
}
.hint {
  color: #d7544c;
  font-size: 0.4rem;
}
.close {
  display: flex;
  padding: 0 0.3rem;
  margin-top: 20px;
  font-size: 0.4rem;
  justify-content: space-evenly;
}
.close button {
  width: 45%;
  height: 1rem;
  line-height: 1rem;
  font-size: 0.5rem;
  color: white;
  background: #31a183;
  border-radius: 0.3rem;
  box-sizing: border-box;
}
.add {
  border: 0;
  height: 1rem;
  width: 50%;
  background: #31a183;
  color: white;
  border-radius: 0.3rem;
  margin-right: 20px;
  margin-bottom: 20px;
}
.amount {
  cursor:pointer
}
.but {
  /* margin-left: 200px; */
}



// .select-shopping {
//   height: 30px;
//   position: absolute;
//   left: -4px;
// }
.zz {
  display: inline-block;
  border-bottom: 1px solid #ccc;
  width: 95%;
  margin: 0 auto;
  margin-bottom: 3px;
  text-align: center;
  line-height: 23px;
  padding: 0.2rem;
}
.q {
  background: #f0eded;
  border-radius: 5px;
  padding: 0.1rem;
}
.smbut {
  width: 100%;
  height: 1rem;
  border-radius: 10px;
  border: 0;
  background: #31a183;
  color: white;
  margin-bottom: 80px;
}

.works-icon {
  width: 55%;
  position: absolute;
  left: 0.21rem;
  top: 50%;
  transform: translateY(-50%);
  text-align: left;
  display: flex;
  // justify-content: space-between;
}

.check-img-about {
  position: absolute;
  right: 30px;
  bottom: 33%;
  height: 40px;
  font-size: 1rem;
  color: #78adcb;
}
.icon-tianjia {
  font-size: 1rem;
  color: #31a183;
  margin: 0 15px;
}
.icon-qunfengshanchuchong {
  font-size: 0.95rem;
  color: red;
  // margin-left: 30px;
}

.remark-input {
  width: 90%;
 border: 0;
 background: #f6f6f6;
 border-radius: 8px;
  padding: .2rem;
}
.remark {
  display: inline-block;
  display: flex;
  width: 100%;
  overflow: hidden;
}
.remark-title {
  position: relative;
  font-size: 0.37rem;
  margin-top: 10px;
}



.icon-qicaodianjihou{
  margin-left: 9px;
  /* margin-bottom: 20px; */
  display: inline-block;
  height: 20px !important;
  line-height: 22px;
  position: absolute;
  right: .31rem;
}
.remark-text{
  height: 50px;
  line-height: 53px;
}


.organ{
  font-size: 0.33rem;
  color: rgb(143, 139, 139);
  text-align: left;
}

.unfold{
  float: right;color:#78adcb;
}
</style>
